if (!customElements.get('vertigo-photo-strip')) {
  class VertigoPhotoStrip extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-vsg-track]');
      this.range = this.querySelector('[data-vsg-range]');
      if (!this.track || !this.range) return;
      this.handleScroll = () => {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.range.value = max > 0 ? String(Math.round(this.track.scrollLeft / max * 100)) : '0';
        this.range.disabled = max === 0;
      };
      this.handleInput = () => {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.track.scrollLeft = max * Number(this.range.value) / 100;
      };
      this.handleResize = () => this.handleScroll();
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      this.range.addEventListener('input', this.handleInput);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.track);
      }
      this.handleScroll();
    }
    disconnectedCallback() {
      if (this.track && this.handleScroll) this.track.removeEventListener('scroll', this.handleScroll);
      if (this.range && this.handleInput) this.range.removeEventListener('input', this.handleInput);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }
  }
  customElements.define('vertigo-photo-strip', VertigoPhotoStrip);
}